import React from 'react';
const contents = [{
  emoji: '📘',
  title: '6 Volumi Scuola Primaria',
  desc: 'Pianificazione annuale classe per classe (1ª-5ª) + Volume Progetti Speciali'
}, {
  emoji: '📐',
  title: '6 Volumi Scuola Secondaria',
  desc: 'Dalla 1ª Media al Biennio delle Superiori, con struttura didattica completa'
}, {
  emoji: '⚽',
  title: '480 Sessioni Passo dopo Passo',
  desc: 'Con materiali, grafici, varianti e tempi di esecuzione'
}, {
  emoji: '📊',
  title: 'Strumenti di Valutazione',
  desc: 'Rubriche e griglie di valutazione pronte per ogni livello'
}, {
  emoji: '⚡',
  title: 'Riscaldamento e Attivazioni',
  desc: 'Dinamiche creative per iniziare ogni lezione nel modo giusto'
}, {
  emoji: '🌱',
  title: 'Contenuti Teorici e Salute',
  desc: "Schede su igiene, anatomia e corretti stili di vita pronti all'uso"
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 Cosa contiene il Pack EDUFIS PRONTO?
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm transition-all hover:shadow-md hover:-translate-y-0.5" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}